export const sliderItems = [

    // <Image src={"/images/trackify.jpg"} />

{
    id: 1,
    img: "/images/car-head-light.jpg",
    title: "DIWALI SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4"
  },
  {
    id: 2,
    img: "/images/car-fog-light.jpg",
    title: "PREMIUM COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "/images/car-interior-light.jpg",
    title: "INTERIOR PREMIUM COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
];

export const categories = [
    {
      id: 1,
      img: "/images/car-fog-light.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Car Service!",
      cat:"Car service"
    },
    {
      id: 2,
      img: "/images/armrest.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Riding Style!",
      cat:"Riding Style",
    },
    {
      id: 3,
      img: "/images/car-body-cover.jpg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      title: "Spare Parts",
      cat:"Spare Parts"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"/images/car-exterior-chrome.jpg",
    },
    {
      id:2,
      img:"/images/car-front-grill.jpg",
    },
    {
      id:3,
      img:"/images/carmirror.jpg",
    },
    {
      id:4,
      img:"/images/car-sunshade.jpg",
    },
    {
      id:5,
      img:"/images/car-steering-wheel-cover.jpg",
    },
    {
      id:6,
      img:"/images/floor-mats.jpg",
    },
    {
      id:7,
      img:"/images/paddle-kit.jpg",
    },
    {
      id:8,
      img:"/images/car-pillar-light.jpg",
    },
  ]